import { render, staticRenderFns } from "./MarkerAngebotContent.vue?vue&type=template&id=26b676da&scoped=true"
import script from "./MarkerAngebotContent.vue?vue&type=script&lang=js"
export * from "./MarkerAngebotContent.vue?vue&type=script&lang=js"
import style0 from "./MarkerAngebotContent.vue?vue&type=style&index=0&id=26b676da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b676da",
  null
  
)

export default component.exports